import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    TranslateModule
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {
  username: string = '';
  userRole: string = '';
  
  menuItems = [
    { path: '/articles', icon: 'article', label: 'MENU.ARTICLES' },
    { path: '/resellers', icon: 'store', label: 'MENU.RESELLERS' },
    {path:'/suppliers',icon:'store',label:'MENU.SUPPLIERS'},
    { path: '/services', icon: 'build', label: 'MENU.SERVICES' },
    { path: '/customers', icon: 'people', label: 'MENU.CUSTOMERS' },
    { path: '/technicians', icon: 'engineering', label: 'MENU.TECHNICIANS' },
    { path: '/claims', icon: 'assignment', label: 'MENU.CLAIMS' },
    { path: '/invoices', icon: 'receipt', label: 'MENU.INVOICES' },
   { path: '/devis', icon: 'receipt', label: 'MENU.DEVIS' },
   {path:'/purchase-invoice',icon:'receipt',label:"MENU.PURCHASE_INVOICE"}
  ];

  constructor(
    private router: Router,
    private authService: AuthService
  ) {
    this.getUserInfo();
  }

  private getUserInfo(): void {
    // Get user info from auth service
    this.authService.currentUser$.subscribe(user => {
      if (user) {
        this.username = user.username || 'User';
        this.userRole = user.role || 'Administrateur';
      } else {
        // Only try to fetch the user if we have a token (not logging out)
        if (this.authService.getToken()) {
          // If no user is in the BehaviorSubject, try to fetch it
          this.authService.getCurrentUser().subscribe({
            next: (user) => {
              if (user) {
                this.username = user.username || 'User';
                this.userRole = user.role || '';
              }
            },
            error: (err) => {
              console.error('Error fetching user info:', err);
              this.username = 'Guest';
              this.userRole = 'Administrateur';
            }
          });
        } else {
          // We're likely logging out, just clear the user info
          this.username = 'Guest';
          this.userRole = '';
        }
      }
    });
  }

  getCurrentPageTitle(): string {
    const currentItem = this.menuItems.find(item => 
      this.router.url.startsWith(item.path)
    );
    return currentItem?.label || 'MENU.DASHBOARD';
  }

  logout(): void {
    this.authService.logout();
  }
} 
